import type { CmsLink } from '../../schemas/models/CmsLink';
import type { CmsMenuItem } from '../../schemas/models/CmsMenuItem';
import type { CmsApiOptions } from '../types/CmsApiOptions';
import { joinLinks } from './joinLinks';
import { sitePathPrefix } from './sitePathPrefix';

function extractUrl(link: CmsLink | CmsMenuItem | string): string | undefined {
    if (!link) {
        return undefined;
    }
    if (typeof link === 'string') {
        return link;
    }
    if (typeof link === 'object' && 'url' in link) {
        return link.url;
    }
    return link?.href;
}

function prefixUrl(url: string, options?: CmsApiOptions): string {
    const prefix = sitePathPrefix(options);
    if (url.startsWith(prefix)) {
        return url;
    }
    return `/${joinLinks(prefix, url)}`;
}

function isHomePath(url?: string | null): boolean {
    return !url || url === 'home' || url === '/';
}

export function urlForCmsLink(link: CmsLink | CmsMenuItem | string, options?: CmsApiOptions): string {
    const url = extractUrl(link);
    if (!url || isHomePath(url)) {
        return prefixUrl('/home', options);
    }
    // Url has its own scheme (http:, https:, mailto:, tel:, etc.), do not prefix
    if (/^[a-zA-Z][a-zA-Z0-9+.-]*:/.test(url)) {
        return url;
    }
    return prefixUrl(url, options);
}
